import RecommendedInfluencers from "./RecommendedInfluencers";

export default RecommendedInfluencers;
